export interface Data {
    code: number;

    message: string;
}
